import React from 'react';

function Loader(props) {
  return <div className="preloader"></div>;
}

export default Loader;
